import CloudIcon from '@mui/icons-material/Cloud';
import { green, red } from '@mui/material/colors';
import { t } from 'i18next';
import React from 'react';

import MultiSelect from '@sophocles/components/MultiSelect';

class SiteGroupSelectionTable extends React.Component {
  constructor(props) {
    super(props);
  }

  _multiSelectRowGenerator = datum => (
    <div
      style={{
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: '100%',
      }}
    >
      <span
        style={{
          flexGrow: 1,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
        title={`${datum.get('name', 'unknown')}. ${datum.get('description', '')}`}
      >
        {datum.get('name', 'unknown')}. {datum.get('description', '')}
      </span>
      {datum.get('is_virtual', false) && (
        <CloudIcon title="Virtual" style={{ fill: 'var(--text-secondary)', flexShrink: 0 }} />
      )}
    </div>
  );

  render() {
    const { isBillboard, selectData, unSelectData, containerStyle, selectedData, unSelectedData, granted, revoked } =
      this.props;

    const siteGroupsString = isBillboard ? 'Plants' : 'Site Groups';

    return (
      <div>
        <MultiSelect
          containerStyle={containerStyle}
          selectedData={selectedData}
          unSelectedData={unSelectedData}
          granted={granted}
          revoked={revoked}
          onSelectData={selectData}
          onUnSelectData={unSelectData}
          selectedTitle={`Accessible ${siteGroupsString}`}
          unSelectedTitle={`Inaccessible ${siteGroupsString}`}
          rowGenerator={this._multiSelectRowGenerator}
        />

        {!granted.isEmpty() && (
          <div>
            <h4 style={{ color: green[500] }}>{t('users.grantAccessTo', 'Grant Access to:')}</h4>
            <ul>
              {granted.map(sg => (
                <li key={sg.get('id')}>
                  {sg.get('name')}. {sg.get('description')}{' '}
                </li>
              ))}
            </ul>
          </div>
        )}
        {!revoked.isEmpty() && (
          <div>
            <h4 style={{ color: red[500] }}>{t('users.revokeAccessTo', 'Revoke Access to:')}</h4>
            <ul>
              {revoked.map(sg => (
                <li key={sg.get('id')}>
                  {sg.get('name')}. {sg.get('description')}{' '}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    );
  }
}

export default SiteGroupSelectionTable;
